import OrangeTheme from 'main/theme/OrangeTheme';
import type { Config } from 'server/types';

export function initTheme(config: Config) {
    const theme = OrangeTheme(config);

    return theme;
}
